import API from './index';

const api = {
    getReportDetail({ params }) {
        return API.authAPI({
            url: '/approval/get-report-detail',
            method: 'GET',
            params: { ...params },
        });
    },
    saveProtocolDeviation(data) {
        return API.authAPI({
            url: '/approval/save-protocol-deviation',
            method: 'POST',
            data,
        });
    },
    submitProtocolDeviation(data) {
        return API.authAPI({
            url: '/approval/submit-protocol-deviation',
            method: 'POST',
            data,
        });
    },
    downloadDocument(data) {
        return API.authAPI({
            url: `/approval/download-supplementary/${data.id}`,
            method: 'GET',
            responseType: 'blob',
            timeout: 1000 * 60 * 10,
        });
    },
};

export default api;
